import { useStrategyStore } from '../../../store/strategy-store/strategy-store';
import { SideSection as SideSectionCost } from './cost-tab/side-section/side-section';
import { PerformanceTab } from './initiative-performance.type';
import { SideSection as SideSectionRelatedTasks } from './related-tasks-tab/side-section/side-section';
import { SideSection as SideSectionThroughput } from './throughput-tab/side-section/side-section';

export const InitiativePerformanceSideSection = () => {
  const activeTab = useStrategyStore((state) => state.performanceTab);

  switch (activeTab) {
    case PerformanceTab.Throughput:
      return <SideSectionThroughput />;
    case PerformanceTab.Cost:
      return <SideSectionCost />;
    case PerformanceTab.RelatedTasks:
      return <SideSectionRelatedTasks />;
    default:
      return null;
  }
};
